import $ from 'jquery';

import * as Website from '../Config/Website.js';


const Modal = {
  openClass: '.js-modalOpen',
  closeClass: '.js-modalClose',
  wrapperClass: '.js-modal',
  init() {
    this.open();
    this.close();
    this.outsideClose();
  },
  open() {
    $(document).on('click', this.openClass, function() {
      const target = $(this).attr('href');
      const targetElm = $(`${Modal.wrapperClass + target}`);
      $('html').addClass(Website.classList.modalOpen);
      if(typeof Iscroll !== "undefined" && Iscroll.instance) {
        Iscroll.stop();
      }
      targetElm.fadeIn(250, function(){
        $(this).addClass(Website.classList.act);
        if($(this).find('video').length) {
          $(this).find('video').get(0).play();
        }
        if($(this).find('iframe').length) {
          $(this).find('iframe').each(function() {
            if($(this).attr('src').indexOf("youtube" > -1) && $(this).attr('src').indexOf("enablejsapi=1") > -1) {
              const message = '{"event":"command","func":"playVideo","args":""}';
              $(this).get(0).contentWindow.postMessage(message, "*");
            }
          });
        }
      })
      return false;
    });
  },
  close(){
    $(document).on('click', this.closeClass, function() {
      let $modal = $(this).closest(Modal.wrapperClass);
      if (!$modal.length) {
        $modal = $(`${Modal.wrapperClass}.${Website.classList.act}`);
      }
      if (!$modal.length) return;

      if($modal.find('video').length) {
        $modal.find('video').get(0).pause();
      }
      if($modal.find('iframe').length) {
        $modal.find('iframe').each(function() {
          if($(this).attr('src').indexOf("youtube" > -1) && $(this).attr('src').indexOf("enablejsapi=1") > -1) {
            const message = '{"event":"command","func":"stopVideo","args":""}';
            $(this).get(0).contentWindow.postMessage(message, "*");
          }
        });
      }
      $modal.removeClass(Website.classList.act).fadeOut(250, function() {
        $('html').removeClass(Website.classList.modalOpen);
        if(typeof Iscroll !== "undefined" && Iscroll.instance) {
          Iscroll.start();
        }
      });
    });
  },
  outsideClose() {
    $(document).on('click', this.wrapperClass, function(e) {
      const $frame = $(this).find('.p-listDetail__frame');
      if (!$frame.length) return;
      const $target = $(e.target);
      if ($target.closest('.p-listDetail__frame').length) return;
      if ($target.closest(Modal.closeClass).length) return;
      $(this).find(Modal.closeClass).first().trigger('click');
    });
  }
}

export default Modal;